export default __webpack_public_path__ + "static/media/googleShopping.749e95b4.svg";